import { rootLinks } from '../app/links';

const base = `${rootLinks.inner()}/mentorProfile`;

export const mentorProfileLinks = {
  root: () => base,
  bio: () => `${base}/bio`,
  editJobExperience: () => `${base}/jobExperience`,
  editEducationExperience: () => `${base}/educationExperience`,
  editLanguages: () => `${base}/editLanguages`,
  submitProfile: () => `${base}/submitProfile`,
  skills: () => `${base}/skills`,
  addSkills: () => `${base}/addSkills`,
  training: () => `${base}/training`,
  topicDetails: () => `${base}/sessions/topicDetails`,
  topicSessions: (id: number) => `${base}/sessions/topic/${id}/schedule`,
};

export default mentorProfileLinks;
